import Joi from 'joi';

export const updateDoctorValidator = (body: unknown) => {
  const schema = Joi.object().keys({
    doctorId: Joi.number().required(),
    firstName: Joi.string().required(),
    lastName: Joi.string().required(),
    middleName: Joi.string().optional().allow(null).allow(''),
    preferredName: Joi.string().optional().allow(null).allow(''),
    email: Joi.string().optional().allow(null).allow(''),
    mobile: Joi.string().optional().allow(null).allow(''),
    phone: Joi.string().optional().allow(null).allow(''),
    hpi: Joi.number().optional().allow(null).allow(''),
    prescriberNumber: Joi.string().optional().allow(null).allow(''),
    providerNumber: Joi.string().optional().allow(null).allow(''),
    internal: Joi.boolean().required(),
    aphraNumber: Joi.string().optional().allow(null).allow(''),
    apExpiry: Joi.alternatives().conditional('operatingUnderSASB', {
      is: true,
      then: Joi.valid(null),
      otherwise: Joi.date().optional(),
    }),
    operatingUnderSASB: Joi.alternatives().conditional('apExpiry', {
      is: Joi.date(),
      then: Joi.valid(false),
      otherwise: Joi.valid(true),
    }),
    address: Joi.object()
      .keys({
        unitNumber: Joi.string().optional().allow(null).allow(''),
        streetNumber: Joi.string().optional().allow(null).allow(''),
        streetName: Joi.string().optional().allow(null).allow(''),
        suburb: Joi.string().optional().allow(null).allow(''),
        city: Joi.string().optional().allow(null).allow(''),
        stateId: Joi.number().optional().allow(null).allow('').allow(NaN),
        businessName: Joi.string().optional().allow(null).allow(''),
        addressType: Joi.string().optional().allow(null).allow(''),
        postCode: Joi.number().optional().allow(null).allow(''),
        isDefaultAddress: Joi.boolean().required(),
        country: Joi.string().optional().allow(null).allow(''),
      })
      .optional(),
  });

  const { error } = schema.validate(body);

  console.log(error);

  return error ? error.details : false;
};
